import './admin/admin.less';

if (document.getElementById('vue-admin-cabinet')) {
    import('./admin/admin.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('order-one')) {
    import('./barcode-order/index.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('app-wildberries-pickup')) {
    import('./wildberries-pickup/index.js').then(function (module) {
        module.default;
    });
}